const FeeFrequencyEnum = Object.freeze({
    MONTHLY: 'MONTHLY',
    ANNUAL: 'ANNUAL'
});

export default FeeFrequencyEnum;
